export default "__VITE_ASSET__DlAOH0iL__"